import { severityClass } from '../utils/severity.js';

/**
 * Reusable pill badge. `variant` is CRITICAL|WARNING|LOW|OK|FAIL|PASS|NA.
 * `size` is 'sm' or 'md' (default).
 */
export function Badge({ variant, size = 'md', children, className = '' }) {
  const sizeClass = size === 'sm' ? 'badge-sm' : '';
  const cls = severityClass(variant);
  return (
    <span className={`badge badge-${cls} ${sizeClass} ${className}`.trim()}>{children}</span>
  );
}
